import React, { memo } from 'react';
import { Card, CardBody } from './Card';

/**
 * MetricBreakdown - Displays grouped metrics in a breakdown format
 * @param {Object} props
 * @param {string} props.title - Card title
 * @param {Array} props.items - Array of { label, value, suffix?, highlight? } objects
 * @param {string} [props.className] - Additional CSS classes
 */
export const MetricBreakdown = memo(function MetricBreakdown({
  title,
  items = [],
  className = ''
}) {
  return (
    <Card className={`bg-base-100 ${className}`}>
      <CardBody>
        <h3 className="text-base font-semibold text-base-content mb-4">{title}</h3>
        <div className="space-y-3">
          {items.map((item, index) => (
            <div key={index} className="flex items-center justify-between">
              <span className="text-sm text-base-content/70">{item.label}:</span>
              <span className={`text-sm font-medium ${
                item.highlight ? 'text-primary' : 'text-base-content'
              }`}>
                {typeof item.value === 'number' ? item.value.toLocaleString() : item.value}
                {item.suffix && <span className="text-base-content/70 ml-1">{item.suffix}</span>}
              </span>
            </div>
          ))}
        </div>
      </CardBody>
    </Card>
  );
});

export default MetricBreakdown;